import { getSidebarStatus, getSize } from '@/utils/cookies'

export enum DeviceType {
    Mobile,
    Desktop,
}

export interface AppState {
    device: DeviceType
    sidebar: {
        opened: boolean
        withoutAnimation: boolean
    }
    size: string,
    language: string,
    globalLoading: boolean //  全局加载中效果
}

export const state: AppState = {
    device: DeviceType.Desktop,
    sidebar: {
        opened: getSidebarStatus() !== 'closed',
        withoutAnimation: true
    },
    size: getSize() || 'medium',
    globalLoading: false,
    language: 'zh'
}
